module.exports = __webpack_public_path__ + "img/illus-mint.2a71f976.png";